import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { TextField } from "@mui/material";
function SaareGaamaUserData() {
  const columns = [
    { id: "Email", label: "Email", minWidth: 170 },
    { id: "Url", label: "url", minWidth: 100 },
    {
      id: "EntryTime",
      label: "Entry Time",
      minWidth: 130,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "ActionTime",
      label: "Action Time",
      minWidth: 130,
      align: "right",
      format: (value) => value.toFixed(2),
    },
    {
      id: "Status",
      label: "Status",
      minWidth: 130,
      align: "right",
      format: (value) => value.toFixed(2),
    },
    {
      id: "Processed",
      label: "Processed",
      minWidth: 170,
      align: "right",
      format: (value) => value.toFixed(2),
    },
    {
      id: "Amount",
      label: "Amount",
      minWidth: 170,
      align: "right",
      format: (value) => value.toFixed(2),
    },
  ];

  function createData(
    Email,
    Url,
    EntryTime,
    ActionTime,
    Status,
    Processed,
    Amount
  ) {
    return { Email, Url, EntryTime, ActionTime, Status, Processed, Amount };
  }

  const rows = [
    createData("India", "IN", 1324171354, 3287263, "yes", "24july2022", 5000),
    createData("China", "CN", 1403500365, 9596961, "yes", "24july2022", 5000),
    createData("Italy", "IT", 60483973, 301340, "yes", "24july2022", 5000),
    createData(
      "United States",
      "US",
      327167434,
      9833520,
      "yes",
      "24july2022",
      5000
    ),
    createData("Canada", "CA", 37602103, 9984670, "yes", "24july2022", 5000),
    createData("Australia", "AU", 25475400, 7692024, "yes", "24july2022", 5000),
    createData("Germany", "DE", 83019200, 357578, "yes", "24july2022", 5000),
    createData("Ireland", "IE", 4857000, 70273, "yes", "24july2022", 5000),
    createData("Mexico", "MX", 126577691, 1972550, "yes", "24july2022", 5000),
    createData("Japan", "JP", 126317000, 377973, "yes", "24july2022", 5000),
    createData("France", "FR", 67022000, 640679, "yes", "24july2022", 5000),
    createData(
      "United Kingdom",
      "GB",
      67545757,
      242495,
      "yes",
      "24july2022",
      5000
    ),
    createData("Russia", "RU", 146793744, 17098246, "yes", "24july2022", 5000),
    createData("Nigeria", "NG", 200962417, 923768, "yes", "24july2022", 5000),
    createData("Brazil", "BR", 210147125, 8515767, "yes", "24july2022", 5000),
  ];

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Typography
          component="h4"
          variant="h4"
          color="inherit"
          noWrap
          sx={{ ml: 3, fontSize: "22px", fontWeight: "700" }}
        >
          Select Saaregama User Data to change
        </Typography>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between", // keep right padding when drawer closed
          }}
        >
          <TextField
            margin="normal"
            id="filter"
            label="Filter"
            name="filter"
            placeholder="ex walmart"
            autoFocus
            variant="standard"
          />
        </Toolbar>
      </Box>

      {/* ll */}

      <Paper
        sx={{
          width: "98%",
          overflow: "hidden",
          mx: 3,
          boxShadow:
            "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
        }}
      >
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.code}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[20, 50, 75, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* ll */}
    </>
  );
}

export default SaareGaamaUserData;
